import { CustomTable } from "./CustomTable";
import { InlineCheckbox } from "../../utility/styledComponents";

export const HealthScoreDeviceDetailTable = (props) => {
  const columnDetails = [
    {
      title: "Fields",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Values",
      dataIndex: "value",
      key: "value",
      color: "textColor",
    },
  ];

  const renderedDetailsColumns = columnDetails.map((item) => {
    return {
      title: () => {
        return (
          <div
            className="sasp_font-size-14 sas_font-weight-bold"
            style={{ margin: "0px", padding: "8px 10px" }}
          >
            {item.title}
          </div>
        );
      },
      render: (text, record) => {
        const fontWeight =
          item.key === "value"
            ? "sasp_font-weight-bold"
            : "sasp_font-weight-400";
        const textColor = item.key === "value" ? record[item?.color] : "";
        return {
          children: (
            <>
              <h5
                className={`sasp_font-size-14 ${fontWeight} ${textColor}`}
                style={{ color: textColor, margin: "0px", padding: "4px 10px" }}
              >
                {record[item.key]}
              </h5>
            </>
          ),
        };
      },
    };
  });

  return (
    <CustomTable
      {...props}
      renderedColumns={renderedDetailsColumns}
      className="sasp_common-table"
    />
  );
};

export const UserGroupsCommonTable = (props) => {
  const userTableColumn = [
    {
      title: "First Name",
      dataIndex: "firstname",
      key: "firstname",
    },
    {
      title: "Last Name",
      dataIndex: "lastname",
      key: "lastname",
    },
    {
      title: "Contact Number",
      dataIndex: "mdn",
      key: "mdn",
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
    },
  ];
  const renderedDetailsColumns = userTableColumn.map((item) => {
    return {
      title: () => {
        return (
          <div
            className="sasp_font-size-14 sasp_font-weight-bold"
            style={{ margin: "0px", padding: "8px 10px" }}
          >
            {item.title}
          </div>
        );
      },
      render: (text, record) => {
        return {
          children: (
            <>
              <h5
                className={`sasp_font-size-14`}
                style={{ padding: "5px 10px" }}
              >
                {record[item.key]}
              </h5>
            </>
          ),
        };
      },
    };
  });

  return (
    <CustomTable
      {...props}
      renderedColumns={renderedDetailsColumns}
      className="sasp_common-table"
    />
  );
};

export const CreateGroupCommonTable = (props) => {
  const { isGroupLink, handleGroupInputChange, groupUsers } = props;
  let userTableColumn = [
    {
      title: "First Name",
      dataIndex: "firstname",
      key: "firstname",
      hasCheckBox: true,
      customStyle: { minWidth: "125px", width: "25%" },
    },
    {
      title: "Last Name",
      dataIndex: "lastname",
      key: "lastname",
      customStyle: { minWidth: "125px", width: "25%" },
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      customStyle: { minWidth: "150px", width: "50%" },
    },
  ];
  if (isGroupLink) {
    userTableColumn = [
      {
        title: "First Name",
        dataIndex: "firstname",
        key: "firstname",
      },
      {
        title: "Last Name",
        dataIndex: "lastname",
        key: "lastname",
      },
      {
        title: "Contact Number",
        dataIndex: "mdn",
        key: "mdn",
      },
      {
        title: "Email ID",
        dataIndex: "email",
        key: "email",
      },
    ];
  }
  const renderedDetailsColumns = userTableColumn.map((item) => {
    return {
      title: () => {
        return (
          <div
            className="sasp_font-size-14 sasp_font-weight-bold"
            style={{ margin: "0px", padding: "8px 10px", ...item?.customStyle }}
          >
            {item.title}
          </div>
        );
      },
      render: (text, record) => {
        return {
          children: (
            <>
              <div
                className="sasp_d-flex"
                style={{
                  paddingLeft: item.hasCheckBox ? "10px" : "",
                  paddingTop: item.hasCheckBox ? "5px" : "",
                }}
              >
                {item.hasCheckBox && (
                  <InlineCheckbox
                    selected={groupUsers.some((elm) => elm?.id === record?.id)}
                    value={record.id}
                    onChange={(e) => {
                      handleGroupInputChange(e, "checkbox", record);
                    }}
                    width="auto"
                  />
                )}
                <h5
                  className={`sasp_font-size-14`}
                  style={{ margin: "0px", padding: "5px 10px" }}
                >
                  {record[item.key]}
                </h5>
              </div>
            </>
          ),
        };
      },
    };
  });

  return (
    <CustomTable
      {...props}
      renderedColumns={renderedDetailsColumns}
      className="sasp_common-table"
    />
  );
};

export const AddUserToGroupCommonTable = (props) => {
  const { handleAddGroupCheckBoxChange, addToGroupId } = props;
  const userTableColumn = [
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      hasCheckBox: true,
      customStyle: { minWidth: "125px", width: "25%" },
    },
    {
      title: "Group Description",
      dataIndex: "description",
      key: "description",
      customStyle: { minWidth: "150px", width: "50%" },
    },
  ];
  const renderedDetailsColumns = userTableColumn.map((item) => {
    return {
      title: () => {
        return (
          <div
            className="sasp_font-size-14 sasp_font-weight-bold"
            style={{ margin: "0px", padding: "8px 10px", ...item?.customStyle }}
          >
            {item.title}
          </div>
        );
      },
      render: (text, record) => {
        return {
          children: (
            <>
              <div
                className="sasp_d-flex"
                style={{
                  paddingLeft: item.hasCheckBox ? "10px" : "",
                  paddingTop: item.hasCheckBox ? "5px" : "",
                }}
              >
                {item.hasCheckBox && (
                  <InlineCheckbox
                    selected={record.id === addToGroupId}
                    onChange={(e) => handleAddGroupCheckBoxChange(e, record)}
                    width="auto"
                  />
                )}
                <h5
                  className={`sasp_font-size-14`}
                  style={{ margin: "0px", padding: "5px 10px" }}
                >
                  {record[item.key]}
                </h5>
              </div>
            </>
          ),
        };
      },
    };
  });

  return (
    <CustomTable
      {...props}
      renderedColumns={renderedDetailsColumns}
      className="sasp_common-table"
    />
  );
};

export const ViewUserGroupsCommonTable = (props) => {
  const {
    handleAddOrRemoveGroupCheckBoxChange,
    currentUserGroups,
    hasCheckBox,
  } = props;
  const userTableColumn = [
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      hasCheckBox: hasCheckBox,
      customStyle: { minWidth: "125px", width: "25%" },
    },
    {
      title: "Group Description",
      dataIndex: "description",
      key: "description",
      customStyle: { minWidth: "150px", width: "50%" },
    },
  ];
  const renderedDetailsColumns = userTableColumn.map((item) => {
    return {
      title: () => {
        return (
          <div
            className="sasp_font-size-14 sasp_font-weight-bold"
            style={{ margin: "0px", padding: "8px 10px", ...item?.customStyle }}
          >
            {item.title}
          </div>
        );
      },
      render: (text, record) => {
        return {
          children: (
            <>
              <div
                className="sasp_d-flex"
                style={{
                  paddingLeft: item.hasCheckBox ? "10px" : "",
                  paddingTop: item.hasCheckBox ? "5px" : "",
                }}
              >
                {item.hasCheckBox && (
                  <InlineCheckbox
                    selected={currentUserGroups?.some(
                      (elm) => elm.id === record.id
                    )}
                    onChange={(e) =>
                      handleAddOrRemoveGroupCheckBoxChange(
                        e,
                        "checkbox",
                        record
                      )
                    }
                    width="auto"
                  />
                )}
                <h5
                  className={`sasp_font-size-14`}
                  style={{ margin: "0px", padding: "5px 10px" }}
                >
                  {record[item.key]}
                </h5>
              </div>
            </>
          ),
        };
      },
    };
  });

  return (
    <CustomTable
      {...props}
      renderedColumns={renderedDetailsColumns}
      className="sasp_common-table"
    />
  );
};
